import { ThemeProvider } from '@data-delivery/d3s';
import {
  ConfigProvider,
  getConfig,
  loadConfig,
} from '@data-delivery/permission-ui-shared-environment';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import 'unfonts.css';
import App from './app/app';
import { initializeSplunkRum, initSessionRecorder } from './app/splunk-config';
import './styles.scss';

const rootEl = document.getElementById('root');

if (!rootEl) {
  throw new Error('root element is not found');
}

const renderApp = async () => {
  const root = ReactDOM.createRoot(rootEl);
  await loadConfig();

  const { VITE_REST_URL, ENABLE_RUM, VITE_PERMISSION_API_URL } = getConfig();

  localStorage.setItem('apiUrl', VITE_REST_URL);
  localStorage.setItem('permission_API_URL', VITE_PERMISSION_API_URL);

  if (ENABLE_RUM && window.location.protocol === 'https:') {
    initializeSplunkRum();
    initSessionRecorder();
  }

  root.render(
    <StrictMode>
      <ConfigProvider>
        <ThemeProvider defaultTheme='system' storageKey='sftp-ui-theme'>
          <App />
        </ThemeProvider>
      </ConfigProvider>
    </StrictMode>,
  );
};

renderApp();
